import { Pipe, PipeTransform } from '@angular/core';
import { CurrentActivatedPlan } from 'src/app/models/activated-subscription.model';
import { resolveActivePlan } from 'src/app/services/subscription/subscription-plan.mapper';

@Pipe({
  name: 'getActiveSubsObject'
})
export class GetActivePlanDetails implements PipeTransform {
  /**
   * Returns the user's current plan from the displayed plan list, with the
   * subscription details (invoices, next billing...) attached. Matching is by
   * razorpay plan id, so old plans (shown as legacy cards) resolve too.
   */
  transform(activateSubsData: CurrentActivatedPlan, subsPlanList: Array<any>, _activatedSubs: any = ""): any {
    const activeSubscriptions = activateSubsData?.activeSubscriptions ?? [];
    if (activeSubscriptions.length === 0) {
      return this.findByTier(subsPlanList, 'tier0', activateSubsData);
    }
    const resolved = resolveActivePlan(subsPlanList, activeSubscriptions);
    if (!resolved) {
      const tier = activateSubsData.subscriptionTiers?.includes('tier2') ? 'tier2' : 'tier1';
      return this.findByTier(subsPlanList, tier, activateSubsData);
    }
    return Object.assign(resolved.plan, {
      expiresOnCycleEnd: resolved.subscription.expiresOnCycleEnd,
      invoices: resolved.subscription.invoices,
      nextBillingDueAt: resolved.subscription.nextBillingDueAt,
      subsCreatedAt: resolved.subscription.createdAt,
      planBackendId: resolved.subscription.planId,
      subscriptionId: resolved.subscription.subscriptionId
    });
  }

  /** Fallback when no plan id matches: first plan of the tier with the same commission type. */
  private findByTier(subsPlanList: Array<any>, tier: string, activateSubsData: CurrentActivatedPlan): any {
    const isCommissionPlan = (activateSubsData?.sellerCommissionPercent ?? 0) > 0;
    return subsPlanList.find((item: any) => item.tier === tier && item?.isCommission === isCommissionPlan) ?? "";
  }
}
